export default "__VITE_ASSET__B3uai6q5__"